import { Document, KnowledgeEntry } from './api';

// 模拟文档数据
const mockDocuments: Document[] = [
  {
    id: 1,
    title: '公司规章制度',
    filename: 'company_rules.pdf',
    fileType: 'application/pdf',
    fileSize: 5242880,
    storagePath: '/storage/docs/company_rules.pdf',
    description: '公司最新规章制度文件，包含员工行为准则、奖惩制度等',
    createdAt: '2023-08-15T08:00:00',
    updatedAt: '2023-08-15T08:00:00',
    uploadedBy: '管理员',
    category: '规章制度',
    indexed: true,
    content: '公司规章制度内容...\n\n第一章 总则\n\n第一条 为规范员工行为，提高工作效率，特制定本规章制度。\n\n第二条 本制度适用于公司全体员工。\n\n第二章 考勤制度\n\n第三条 员工必须遵守公司的上下班时间规定，迟到超过三次将被扣除当月绩效奖金。\n\n第四条 请假需提前提交申请，并获得直接主管批准。\n\n第三章 奖惩制度\n\n第五条 员工在工作中表现突出，为公司创造价值的，将给予相应奖励。\n\n第六条 员工违反公司规章制度的，将视情节轻重给予相应处罚。'
  },
  {
    id: 2,
    title: '年度财务报告',
    filename: 'financial_report_2023.xlsx',
    fileType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    fileSize: 3145728,
    storagePath: '/storage/docs/financial_report_2023.xlsx',
    description: '2023年公司财务状况报告',
    createdAt: '2023-12-30T15:30:00',
    updatedAt: '2023-12-30T15:30:00',
    uploadedBy: '财务部',
    category: '财务报告',
    indexed: true,
    content: '# 2023年度财务报告\n\n## 摘要\n公司2023年第四季度营收增长了15%，超过了年初设定的10%的目标。全年营收达到1.25亿元，同比增长12.3%。\n\n## 收入分析\n产品线A: 5500万元 (44%)\n产品线B: 4300万元 (34%)\n产品线C: 2700万元 (22%)\n\n## 支出分析\n研发投入: 3000万元\n市场营销: 2500万元\n运营成本: 1800万元\n人力资源: 3200万元\n\n## 利润分析\n税前利润: 4500万元\n税后净利润: 3600万元\n净利润率: 28.8%\n\n## 投资回报\n股东分红: 1800万元\n投资回报率: 15.2%'
  },
  {
    id: 3,
    title: '产品手册V2.0',
    filename: 'product_manual_v2.docx',
    fileType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    fileSize: 2097152,
    storagePath: '/storage/docs/product_manual_v2.docx',
    description: '最新产品使用说明和技术规格',
    createdAt: '2023-10-10T09:45:00',
    updatedAt: '2023-11-05T14:20:00',
    uploadedBy: '产品部',
    category: '产品文档',
    indexed: false,
    content: '# 产品手册 V2.0\n\n## 产品概述\n本产品是一款高性能工业级设备，专为大型制造企业设计，能满足各种工业场景需求。\n\n## 技术规格\n- 尺寸：120cm x 80cm x 60cm\n- 重量：150kg\n- 功率：2200W\n- 工作温度：-10°C 至 50°C\n- 防护等级：IP65\n\n## 安全须知\n使用本产品前，请仔细阅读以下安全注意事项：\n\n1. 确保设备安装在平稳的表面上\n2. 定期检查电源线和连接件是否完好\n3. 避免在极端环境下使用设备\n4. 产品A的最大负载能力为200kg，超过此重量可能导致设备损坏和安全隐患\n\n## 操作说明\n1. 启动设备：按下主电源开关，等待系统自检完成\n2. 设置参数：通过控制面板设置相应参数\n3. 开始运行：按下绿色启动按钮\n4. 停止操作：按下红色停止按钮\n\n## 维护保养\n设备应每月进行一次常规维护，包括清洁、紧固件检查和润滑。'
  }
];

// 模拟知识条目数据
const mockKnowledgeEntries: KnowledgeEntry[] = [
  {
    id: 1,
    content: '员工必须遵守公司的上下班时间规定，迟到超过三次将被扣除当月绩效奖金。',
    embedding: '',
    document: mockDocuments[0],
    startPosition: 120,
    endPosition: 180,
    createdAt: '2023-08-16T10:00:00',
    updatedAt: '2023-08-16T10:00:00'
  },
  {
    id: 2,
    content: '公司2023年第四季度营收增长了15%，超过了年初设定的10%的目标。',
    embedding: '',
    document: mockDocuments[1],
    startPosition: 200,
    endPosition: 250,
    createdAt: '2023-12-31T09:00:00',
    updatedAt: '2023-12-31T09:00:00'
  },
  {
    id: 3,
    content: '产品A的最大负载能力为200kg，超过此重量可能导致设备损坏和安全隐患。',
    embedding: '',
    document: mockDocuments[2],
    startPosition: 500,
    endPosition: 550,
    createdAt: '2023-10-12T13:30:00',
    updatedAt: '2023-10-12T13:30:00'
  }
];

// 文档相关API
export const mockDocumentApi = {
  // 获取所有文档
  getAllDocuments: async (): Promise<Document[]> => {
    return Promise.resolve(mockDocuments);
  },
  
  // 获取单个文档
  getDocumentById: async (id: number): Promise<Document> => {
    const document = mockDocuments.find(doc => doc.id === id);
    if (!document) {
      return Promise.reject(new Error('Document not found'));
    }
    return Promise.resolve(document);
  },
  
  // 搜索文档
  searchDocuments: async (title: string): Promise<Document[]> => {
    const filteredDocs = mockDocuments.filter(doc => 
      doc.title.toLowerCase().includes(title.toLowerCase())
    );
    return Promise.resolve(filteredDocs);
  },
  
  // 获取特定分类的文档
  getDocumentsByCategory: async (category: string): Promise<Document[]> => {
    const filteredDocs = mockDocuments.filter(doc => doc.category === category);
    return Promise.resolve(filteredDocs);
  },
  
  // 上传文档
  uploadDocument: async (formData: FormData): Promise<Document> => {
    const newId = mockDocuments.length + 1;
    const file = formData.get('file') as File;
    const fileName = file ? file.name : 'document.pdf';
    const title = formData.get('title') as string || `新文档${newId}`;
    
    // 生成文档内容，实际情况中这部分内容应该是从文件解析出来的
    let documentContent = `# ${title}\n\n## 文档描述\n${formData.get('description') as string || '暂无描述'}\n\n## 文档内容\n这是一个自动生成的文档内容示例。\n\n上传者: ${formData.get('uploadedBy') as string || '当前用户'}\n分类: ${formData.get('category') as string || '未分类'}\n文件名: ${fileName}\n文件大小: ${file ? formatFileSize(file.size) : '未知'}`;
    
    // 如果是docx文件，添加一些特殊内容使其可被搜索
    if (file && file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
      documentContent += `\n\n## 特殊索引内容\n
      该文档包含以下关键信息：
      - 公司战略规划2024年度
      - 产品发展路线图
      - 市场营销策略
      - 财务预算分析
      - 人员配置计划
      \n这是一份重要的内部文档，请妥善保管和使用。`;
    }
    
    const newDocument: Document = {
      id: newId,
      title: title,
      filename: fileName,
      fileType: file ? file.type : 'application/pdf',
      fileSize: file ? file.size : 1048576,
      storagePath: `/storage/docs/document_${newId}.pdf`,
      description: formData.get('description') as string || '',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      uploadedBy: formData.get('uploadedBy') as string || '当前用户',
      category: formData.get('category') as string || '未分类',
      indexed: true, // 自动设置为已索引
      content: documentContent
    };
    
    mockDocuments.push(newDocument);
    
    // 为文档自动创建几个知识条目，便于搜索
    const contentParagraphs = documentContent.split('\n\n').filter(p => p.trim().length > 10);
    for (let i = 0; i < Math.min(contentParagraphs.length, 3); i++) {
      const newEntryId = mockKnowledgeEntries.length + 1;
      const newEntry: KnowledgeEntry = {
        id: newEntryId,
        content: contentParagraphs[i].replace(/[#\n]/g, ' ').trim(),
        embedding: '',
        document: newDocument,
        startPosition: i * 100,
        endPosition: (i + 1) * 100 - 1,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      };
      mockKnowledgeEntries.push(newEntry);
    }
    
    return Promise.resolve(newDocument);
  },
  
  // 批量上传文档（mock）
  uploadDocumentsBatch: async (formData: FormData): Promise<Document[]> => {
    const files = formData.getAll('files') as File[];
    const results: Document[] = [];
    if (!files || files.length === 0) return results;

    for (const f of files) {
      const single = new FormData();
      single.append('file', f);
      single.append('title', f.name);
      single.append('description', f.name);
      single.append('uploadedBy', (formData.get('uploadedBy') as string) || '当前用户');
      const category = formData.get('category') as string | null;
      if (category) single.append('category', category);
      const created = await (mockDocumentApi.uploadDocument(single));
      results.push(created);
    }
    return results;
  },
  
  // 删除文档
  deleteDocument: async (id: number): Promise<void> => {
    const index = mockDocuments.findIndex(doc => doc.id === id);
    if (index !== -1) {
      mockDocuments.splice(index, 1);
    }
    return Promise.resolve();
  },
  
  // 获取未索引的文档
  getUnindexedDocuments: async (): Promise<Document[]> => {
    const unindexedDocs = mockDocuments.filter(doc => !doc.indexed);
    return Promise.resolve(unindexedDocs);
  },
  
  // 标记文档为已索引
  markAsIndexed: async (id: number): Promise<void> => {
    const document = mockDocuments.find(doc => doc.id === id);
    if (document) {
      document.indexed = true;
    }
    return Promise.resolve();
  },
  
  // 处理和索引文档（包括生成知识条目和嵌入向量）
  processAndIndexDocument: async (id: number): Promise<void> => {
    const document = mockDocuments.find(doc => doc.id === id);
    if (document) {
      document.indexed = true;
    }
    return Promise.resolve();
  },
};

// 知识条目相关API
export const mockKnowledgeEntryApi = {
  // 获取所有知识条目
  getAllEntries: async (): Promise<KnowledgeEntry[]> => {
    return Promise.resolve(mockKnowledgeEntries);
  },
  
  // 获取单个知识条目
  getEntryById: async (id: number): Promise<KnowledgeEntry> => {
    const entry = mockKnowledgeEntries.find(entry => entry.id === id);
    if (!entry) {
      return Promise.reject(new Error('Knowledge entry not found'));
    }
    return Promise.resolve(entry);
  },
  
  // 获取特定文档的知识条目
  getEntriesByDocumentId: async (documentId: number): Promise<KnowledgeEntry[]> => {
    const entries = mockKnowledgeEntries.filter(entry => entry.document.id === documentId);
    return Promise.resolve(entries);
  },
  
  // 文本搜索
  searchByContent: async (query: string): Promise<KnowledgeEntry[]> => {
    // 先搜索已有的知识条目
    const filteredEntries = mockKnowledgeEntries.filter(entry => 
      entry.content.toLowerCase().includes(query.toLowerCase())
    );
    
    // 如果没有找到足够的结果，搜索文档内容并创建临时知识条目
    if (filteredEntries.length < 2) {
      const searchedDocs = mockDocuments.filter(doc => 
        doc.content && doc.content.toLowerCase().includes(query.toLowerCase())
      );
      
      // 为匹配的文档创建临时知识条目
      for (const doc of searchedDocs) {
        // 避免重复，检查该文档是否已经在结果中
        if (!filteredEntries.some(entry => entry.document.id === doc.id)) {
          // 找到匹配的片段
          const content = doc.content || '';
          const lowerContent = content.toLowerCase();
          const lowerQuery = query.toLowerCase();
          
          if (lowerContent.includes(lowerQuery)) {
            // 找到匹配位置前后100个字符作为上下文
            const matchIndex = lowerContent.indexOf(lowerQuery);
            const start = Math.max(0, matchIndex - 100);
            const end = Math.min(content.length, matchIndex + query.length + 100);
            const matchedContent = content.substring(start, end);
            
            // 创建临时知识条目
            const tempEntry: KnowledgeEntry = {
              id: 10000 + doc.id, // 使用较大ID避免冲突
              content: `...${matchedContent}...`,
              embedding: '',
              document: doc,
              startPosition: start,
              endPosition: end,
              createdAt: new Date().toISOString(),
              updatedAt: new Date().toISOString()
            };
            
            filteredEntries.push(tempEntry);
          }
        }
      }
    }
    
    return Promise.resolve(filteredEntries);
  },
  
  // 语义搜索 (增强版，会深入搜索文档内容)
  searchSemantic: async (query: string, limit: number = 10): Promise<KnowledgeEntry[]> => {
    // 复用文本搜索的结果
    const textResults = await mockKnowledgeEntryApi.searchByContent(query);
    
    // 为每个结果添加"相关度"评分
    const scoredResults = textResults.map(entry => {
      // 简单评分算法：
      // 1. 如果标题包含查询词，加3分
      // 2. 如果内容包含查询词，加2分 
      // 3. 如果文档描述包含查询词，加1分
      let score = 0;
      const lowerQuery = query.toLowerCase();
      
      if (entry.document.title.toLowerCase().includes(lowerQuery)) {
        score += 3;
      }
      
      if (entry.content.toLowerCase().includes(lowerQuery)) {
        score += 2;
      }
      
      if (entry.document.description.toLowerCase().includes(lowerQuery)) {
        score += 1;
      }
      
      return { entry, score };
    });
    
    // 按分数排序并限制结果数量
    scoredResults.sort((a, b) => b.score - a.score);
    return Promise.resolve(scoredResults.slice(0, limit).map(item => item.entry));
  },
  
  // 为文档创建索引
  indexDocument: async (documentId: number): Promise<void> => {
    const document = mockDocuments.find(doc => doc.id === documentId);
    if (document) {
      document.indexed = true;
    }
    return Promise.resolve();
  },
  
  // 生成嵌入向量
  generateEmbeddings: async (): Promise<void> => {
    return Promise.resolve();
  },
  
  // 删除知识条目
  deleteEntry: async (id: number): Promise<void> => {
    const index = mockKnowledgeEntries.findIndex(entry => entry.id === id);
    if (index !== -1) {
      mockKnowledgeEntries.splice(index, 1);
    }
    return Promise.resolve();
  },
};

// 文件大小格式化辅助函数
const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}; 